
import get from "lodash/get"

const styles = theme => ({
    root: {
        position: "absolute",
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100vw",
        height: get(theme, "customTheme.sizes.bottomControlsHeight"),
        background: "transparent",
    },
    
    control: {
        paddingTop: `0 !important`,
        paddingBottom: 0,
    },
})

export default styles



// WEBPACK FOOTER //
// ./src/lib/components/BottomControls/styles.js